import React from "react";
import HomeImage from "../oryza/partials/images/hotelbg/slider.jpg";
import Oryza1 from "../oryza/partials/images/oryzaleisure/mobile/pettipetti/1.jpg";
import Oryza2 from "../oryza/partials/images/oryzaleisure/mobile/pettipetti/2.jpg";
import Oryza3 from "../oryza/partials/images/oryzaleisure/mobile/pettipetti/3.jpg";
import Kent1 from "../oryza/partials/images/oryzaleisure/mobile/kent/1.jpg";
import Kent2 from "../oryza/partials/images/oryzaleisure/mobile/kent/2.jpg";
import Kent3 from "../oryza/partials/images/oryzaleisure/mobile/kent/3.jpg";
import BBM1 from "../oryza/partials/images/oryzaleisure/mobile/bbm/1.jpg";
import BBM2 from "../oryza/partials/images/oryzaleisure/mobile/bbm/2.jpg";
import BBM3 from "../oryza/partials/images/oryzaleisure/mobile/bbm/3.jpg";
import BBK1 from "../oryza/partials/images/oryzaleisure/mobile/bbk/1.jpg";
import BBK2 from "../oryza/partials/images/oryzaleisure/mobile/bbk/2.jpg";
import BBK3 from "../oryza/partials/images/oryzaleisure/mobile/bbk/3.jpeg";
import Share1 from "../oryza/partials/images/oryzaleisure/share/1.webp";
import Share2 from "../oryza/partials/images/oryzaleisure/share/2.webp";
import Share3 from "../oryza/partials/images/oryzaleisure/share/3.webp";
import Share4 from "../oryza/partials/images/oryzaleisure/share/4.webp";
import Share5 from "../oryza/partials/images/oryzaleisure/share/5.webp";
import giftvouchers from "../oryza/partials/images/oryzaleisure/giftvouchers.webp";
import Offers from "../oryza/partials/images/oryzaleisure/offers.jpg";
import Pettipetti1 from "../oryza/partials/images/oryzaleisure/pettipetti/1.jpg"
import Pettipetti2 from "../oryza/partials/images/oryzaleisure/pettipetti/2.jpg";
import Pettipetti3 from "../oryza/partials/images/oryzaleisure/pettipetti/3.jpg"
import OryzaKent1 from "../oryza/partials/images/oryzaleisure/kent/1.jpg";
import OryzaKent2 from "../oryza/partials/images/oryzaleisure/kent/2.jpg";
import OryzaKent3 from "../oryza/partials/images/oryzaleisure/kent/3.jpg";
import OryzaBBM1 from "../oryza/partials/images/oryzaleisure/bbm/1.jpg";
import OryzaBBM2 from "../oryza/partials/images/oryzaleisure/bbm/2.jpg";
import OryzaBBM3 from "../oryza/partials/images/oryzaleisure/bbm/3.jpg";
import OryzaBBK1 from "../oryza/partials/images/oryzaleisure/bbk/1.jpg";
import OryzaBBK2 from "../oryza/partials/images/oryzaleisure/bbk/2.jpg";
import OryzaBBK3 from "../oryza/partials/images/oryzaleisure/bbk/3.jpeg";
import "../oryza/partials/main.min.css";
import "../oryza/partials/bootstrap.min.css";
import "../oryza/partials/style.css";

export default function oryzaleisure() {
  return (
    <div id="main">
      <section
        className="section p-t-30 p-b-20 "
        style={{ paddingTop: "70px" }}
      >
        <div className="container welcometitle">
          <div className="page-heading">
            <h4 className="title-sub title-sub--c8 m-b-15">
              Welcome to Oryza Leisure
            </h4>
            <h1 className="title-3">HELLO, ආයුබෝවන්, வணக்கம்</h1>
          </div>
        </div>
      </section>
      <section className="section ">
        <div className="wrap wrap--w1790">
          <div className="container-fluid">
            <img
              src={HomeImage}
              alt="Page Image"
              aria-hidden="true"
              style={{ maxWidth: "100%" }}
            />
          </div>
        </div>
      </section>

      <section className="section p-t-80 mobilesectionpadding">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-lg-6 desktopview">
              <div className="row no-gutters">
                <div className="col-md-6">
                  <div className="media-statistic-2">
                    <div className="media__body">
                      <span className="media__number js-counterup">10+</span>
                      <h5 className="media__title title-sub">
                        Years of Excellent Service
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="media-statistic-2">
                    <div className="media__body">
                      <span className="media__number js-counterup">120+</span>
                      <h5 className="media__title title-sub">Friendly Staff</h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="media-statistic-2">
                    <div className="media__body">
                      <span className="media__number js-counterup">3</span>
                      <h5 className="media__title title-sub">
                        Destinations in Sri Lanka
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="media-statistic-2">
                    <div className="media__body">
                      <span className="media__number js-counterup">4</span>
                      <h5 className="media__title title-sub">
                        Hotels and Resorts
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <p
                className="text--s18-40 m-b-15"
                style={{ color: "#ffffff", textAlign: "start" }}
              >
                <strong className="text--c2">Explore Sri Lanka </strong>
                in a whole new light and immerse yourself in the grace and
                splendor of this enchanting paradise. Every destination in our
                portfolio holds its own distinct narrative, narrated through our
                outstanding service, daring cuisine, and warm hospitality. Our
                magnificent venues are crafted to blend seamlessly with the
                natural surroundings, crafting an ideal atmosphere for creating
                unforgettable memories.
              </p>
            </div>
            <div className="col-lg-6 mobileview mobilesectionpadding ">
              <div className="row">
                <div className="col-6">
                  <div className="media-statistic-2">
                    <div className="media__body">
                      <span className="media__number js-counterup">10+</span>
                      <h5 className="media__title title-sub">
                        Years of Excellent Service
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="media-statistic-2">
                    <div className="media__body">
                      <span className="media__number js-counterup">120+</span>
                      <h5 className="media__title title-sub">Friendly Staff</h5>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="media-statistic-2">
                    <div className="media__body">
                      <span className="media__number js-counterup">3</span>
                      <h5 className="media__title title-sub">
                        Destinations in Sri Lanka
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="media-statistic-2">
                    <div className="media__body">
                      <span className="media__number js-counterup">4</span>
                      <h5 className="media__title title-sub">
                        Hotels and Resorts
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="p-t-60 mobilesectionpadding">
        <div className="container">
          <div className="section-title">
            <h5 className="title-sub">ORYZA HOTELS AND RESORTS</h5>
            <h2 className="title-1 custom_font">
              UNMISTAKABLE STYLE AND LUXURY
            </h2>
          </div>
        </div>
      </section>

      <section className="wrap wrap--w1790 p-b-25 mobileview">
        <div className="container-fluid">
          <div
            className="slick-wrap slick-project js-slick-wrapper"
            data-slick-xs="1"
            data-slick-sm="1"
            data-slick-md="3"
            data-slick-lg="4"
            data-slick-xl="4"
            data-slick-dots="false"
            data-slick-customnav="true"
            data-slick-autoplay="true"
          >
            <div className="slick-wrap-content">
              <div className="slick-content js-slick-content mobileimageview">
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={Oryza1} alt="" loading="lazy" />
                    </figure>
                    <div className="bg-overlay"></div>
                    <span className="line"></span>
                    <span className="line line--bottom"></span>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://pettipettimirissa.com">Petti Petti Mirissa</a>
                      </h3>
                      <div className="address">Beach Club and Restaurant</div>
                    </div>
                  </article>
                </div>
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={Oryza2} alt="" loading="lazy" />
                    </figure>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://pettipettimirissa.com">
                          Beach Bar and Restaurant
                        </a>
                      </h3>
                    </div>
                  </article>
                </div>
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={Oryza3} alt="" loading="lazy" />
                    </figure>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://pettipettimirissa.com">Black Beach</a>
                      </h3>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wrap wrap--w1790 p-b-25 mobileview">
        <div className="container-fluid">
          <div
            className="slick-wrap slick-project js-slick-wrapper"
            data-slick-xs="1"
            data-slick-sm="1"
            data-slick-md="3"
            data-slick-lg="4"
            data-slick-xl="4"
            data-slick-dots="false"
            data-slick-customnav="true"
            data-slick-autoplay="true"
          >
            <div className="slick-wrap-content">
              <div className="slick-content js-slick-content mobileimageview">
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={Kent1} alt="" loading="lazy" />
                    </figure>
                    <div className="bg-overlay-kent"></div>
                    <span className="line"></span>
                    <span className="line line--bottom"></span>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://kentcottagenuwaraeliya.com">Kent Cottage Nuwara Eliya</a>
                      </h3>
                      <div className="address">Boutique Luxury Villa</div>
                    </div>
                  </article>
                </div>
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={Kent2} alt="" loading="lazy" />
                    </figure>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://kentcottagenuwaraeliya.com">Kent Cottage Nuwara Eliya</a>
                      </h3>
                      <div className="address">Exclusive Privacy</div>
                    </div>
                  </article>
                </div>
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={Kent3} alt="" loading="lazy" />
                    </figure>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://kentcottagenuwaraeliya.com">Kent Cottage Nuwara Eliya</a>
                      </h3>
                      <div className="address">Luxurious Relaxation</div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wrap wrap--w1790 p-b-25 mobileview">
        <div className="container-fluid">
          <div
            className="slick-wrap slick-project js-slick-wrapper"
            data-slick-xs="1"
            data-slick-sm="1"
            data-slick-md="3"
            data-slick-lg="4"
            data-slick-xl="4"
            data-slick-dots="false"
            data-slick-customnav="true"
            data-slick-autoplay="true"
          >
            <div className="slick-wrap-content">
              <div className="slick-content js-slick-content mobileimageview">
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={BBK1} alt="" loading="lazy" />
                    </figure>
                    <div className="bg-overlay-bbk"></div>
                    <span className="line"></span>
                    <span className="line line--bottom"></span>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://bananabunkskandy.com">Banana Bunks Kandy</a>
                      </h3>
                      <div className="address">Hill Country Getaway</div>
                    </div>
                  </article>
                </div>
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={BBK2} alt="" loading="lazy" />
                    </figure>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://bananabunkskandy.com">Banana Bunks Kandy</a>
                      </h3>
                      <div className="address">Cozy Garden</div>
                    </div>
                  </article>
                </div>
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={BBK3} alt="" loading="lazy" />
                    </figure>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://bananabunkskandy.com">Banana Bunks Kandy</a>
                      </h3>
                      <div className="address">Private Pool</div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="wrap wrap--w1790 p-b-25 mobileview">
        <div className="container-fluid">
          <div
            className="slick-wrap slick-project js-slick-wrapper"
            data-slick-xs="1"
            data-slick-sm="1"
            data-slick-md="3"
            data-slick-lg="4"
            data-slick-xl="4"
            data-slick-dots="false"
            data-slick-customnav="true"
            data-slick-autoplay="true"
          >
            <div className="slick-wrap-content">
              <div className="slick-content js-slick-content mobileimageview">
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={BBM1} alt="" loading="lazy" />
                    </figure>
                    <div className="bg-overlay-bbm"></div>
                    <span className="line"></span>
                    <span className="line line--bottom"></span>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://bananabunksmirissa.com">Banana Bunks Mirissa</a>
                      </h3>
                      <div className="address">Beachside Escapes</div>
                    </div>
                  </article>
                </div>
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={BBM2} alt="" loading="lazy" />
                    </figure>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://bananabunksmirissa.com">Banana Bunks Mirissa</a>
                      </h3>
                      <div className="address">
                        Do Not Disturb Mode. Always.
                      </div>
                    </div>
                  </article>
                </div>
                <div className="slick-item">
                  <article className="media media-project">
                    <figure className="media__img">
                      <img src={BBM3} alt="" loading="lazy" />
                    </figure>
                    <div className="media__body">
                      <h3 className="title">
                        <a href="https://bananabunksmirissa.com">Banana Bunks Mirissa</a>
                      </h3>
                      <div className="address">Ultimate Relaxation</div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="p-t-40 p-b-45 desktopview">
        <div className="container">
          <div
            className="masonry-row js-isotope-wrapper"
            data-isotope-hori="true"
          >
            <div className="row isotope-content">
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://pettipettimirissa.com">
                    <figure className="media__img">
                      <img
                        src={Pettipetti2}
                        alt=""
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://pettipettimirissa.com">Beach Bar and Restaurant</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Petti Petti Mirissa
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://pettipettimirissa.com">
                    <figure className="media__img">
                      <img
                        src={Pettipetti3}
                        alt="Oryza Hotels"
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://pettipettimirissa.com">Black Beach</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Petti Petti Mirissa
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://pettipettimirissa.com">
                    <figure className="media__img">
                      <img
                        src={Pettipetti1}
                        alt="Oryza Hotels"
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://pettipettimirissa.com">Petti Petti Mirissa</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Beach Club and Restaurant
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://kentcottagenuwaraeliya.com">
                    <figure className="media__img">
                      <img
                        src={OryzaKent1}
                        alt=""
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://kentcottagenuwaraeliya.com">Kent Cottage Nuwara Eliya</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Boutique Colonial Villa
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://kentcottagenuwaraeliya.com">
                    <figure className="media__img">
                      <img
                        src={OryzaKent2}
                        alt="Oryza Hotels"
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://kentcottagenuwaraeliya.com">Exclusive Privacy</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Kent Cottage Nuwara Eliya
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://kentcottagenuwaraeliya.com">
                    <figure className="media__img">
                      <img
                        src={OryzaKent3}
                        alt="Oryza Hotels"
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://kentcottagenuwaraeliya.com">Luxurious Relaxation</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Kent Cottage Nuwara Eliya
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://bananabunkskandy.com">
                    <figure className="media__img">
                      <img
                        src={OryzaBBK2}
                        alt=""
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://bananabunkskandy.com">Cozy Garden</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Banana Bunks Kandy
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://bananabunkskandy.com">
                    <figure className="media__img">
                      <img
                        src={OryzaBBK3}
                        alt="Oryza Hotels"
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://bananabunkskandy.com">Private Pool</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Banana Bunks Kandy
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://bananabunkskandy.com">
                    <figure className="media__img">
                      <img
                        src={OryzaBBK1}
                        alt="Oryza Hotels"
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://bananabunkskandy.com">Banana Bunks Kandy</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Hill Country Getaway
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://bananabunksmirissa.com">
                    <figure className="media__img">
                      <img
                        src={OryzaBBM1}
                        alt=""
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://bananabunksmirissa.com">Banana Bunks Mirissa</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Beachside Escapes
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://bananabunksmirissa.com">
                    <figure className="media__img">
                      <img
                        src={OryzaBBM2}
                        alt="Oryza Hotels"
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://bananabunksmirissa.com">
                        Do Not Disturb Mode. Always.
                      </a>
                    </h3>
                    <span className="address title-sub--sm">
                      Banana Bunks Mirissa
                    </span>
                  </div>
                </article>
              </div>
              <div className="col-md-6 col-lg-4 isotope-item">
                <article className="media media-project-4 m-b-30">
                  <a href="https://bananabunksmirissa.com">
                    <figure className="media__img">
                      <img
                        src={OryzaBBM3}
                        alt="Oryza Hotels"
                        loading="lazy"
                        style={{ maxWidth: "400px", maxHeight: "350px" }}
                      />
                    </figure>
                  </a>
                  <div className="media__body">
                    <h3 className="media__title title--sm">
                      <a href="https://bananabunksmirissa.com">Ultimate Relaxation</a>
                    </h3>
                    <span className="address title-sub--sm">
                      Banana Bunks Mirissa
                    </span>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap wrap--w1790 desktopview">
          <div className="container-fluid">
            <article className="media-project-3 right">
              <div className="media__body">
                <figure className="media__img">
                  <img src={Offers} alt="offers" style={{ width: "100%" }} />
                </figure>
                <div className="media__content">
                  <div className="pointer"></div>
                  <h4 className="title-sub title-sub--c8">
                    Best and only the best
                  </h4>
                  <h2 className="title-1">EXCLUSIVE OFFERS</h2>
                  <p className="media__text" style={{ color: "#ffffff" }}>
                    Whether it’s the grandeur of a country house, a luxury
                    idyllic hideaway or a romantic retreat, Oryza Leisure have
                    special inclusive offers tailor made for you.
                  </p>
                  <a className="au-btn au-btn--arrow" href="/oryza/offers">
                    See all offers
                    <i className="zmdi zmdi-arrow-right ic-arrow"></i>
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap wrap--w1790 mobileview">
          <div className="container-fluid">
            <article className="media-project-3 right">
              <div className="media__body">
                <div
                  className="media__content"
                  style={{ paddingRight: 0, paddingTop: "10px" }}
                >
                  <div className="pointer"></div>
                  <h4 className="title-sub title-sub--c8">
                    Best and only the best
                  </h4>
                  <h2 className="title-1" style={{ paddingBottom: "10px" }}>
                    EXCLUSIVE OFFERS
                  </h2>
                </div>
                <figure className="media__img">
                  <img src={Offers} alt="offers" style={{ width: "100%" }} />
                </figure>
                <div
                  className="media__content"
                  style={{ paddingRight: 0, paddingTop: "10px" }}
                >
                  <p className="media__text" style={{ color: "#ffffff" }}>
                    Whether it’s the grandeur of a country house, a luxury
                    idyllic hideaway or a romantic retreat, Oryza Leisure have
                    special inclusive offers tailor made for you.
                  </p>
                  <a className="au-btn au-btn--arrow" href="/oryza/offers">
                    See all offers
                    <i className="zmdi zmdi-arrow-right ic-arrow"></i>
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap wrap--w1790 desktopview">
          <div className="container-fluid">
            <article className="media-project-3">
              <div className="media__body">
                <figure className="media__img">
                  <img
                    src={giftvouchers}
                    alt="Gift Vouchers"
                    style={{ width: "100%" }}
                  />
                </figure>
                <div className="media__content">
                  <div className="pointer"></div>
                  <h4 className="title-sub title-sub--c8">Share your love</h4>
                  <h2 className="title-1">GIFT VOUCHERS</h2>
                  <p
                    className="media__text"
                    style={{ color: "#ffffff", textAlign: "start" }}
                  >
                    Give the gift of luxury stay with Oryza Leisure gift
                    vouchers. They can be used as full or part payment for
                    stays.
                  </p>
                  <a className="au-btn au-btn--arrow" href="/oryza/contact">
                    Enquire Gift Vouchers
                    <i className="zmdi zmdi-arrow-right ic-arrow"></i>
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap wrap--w1790 mobileview">
          <div className="container-fluid">
            <article className="media-project-3">
              <div className="media__body">
                <div className="media__content" style={{ paddingTop: "10px" }}>
                  <div className="pointer"></div>
                  <h4 className="title-sub title-sub--c8">Share your love</h4>
                  <h2 className="title-1" style={{ paddingBottom: "10px" }}>
                    GIFT VOUCHERS
                  </h2>
                </div>
                <figure className="media__img">
                  <img
                    src={giftvouchers}
                    alt="Gift Vouchers"
                    style={{ width: "100%" }}
                  />
                </figure>
                <div className="media__content" style={{ paddingTop: "10px" }}>
                  <p
                    className="media__text"
                    style={{ color: "#ffffff", textAlign: "start" }}
                  >
                    Give the gift of luxury stay with Oryza Leisure gift
                    vouchers. They can be used as full or part payment for
                    stays.
                  </p>
                  <a className="au-btn au-btn--arrow" href="/oryza/contact">
                    Enquire Gift Vouchers
                    <i className="zmdi zmdi-arrow-right ic-arrow"></i>
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="p-b-30">
        <div className="wrap wrap--w1790">
          <div className="container-fluid">
            <div className="section-title m-b-40">
              <h5 className="title-sub">
                #oryzaleisure #pettipetti #kentcottage #bananabunks
              </h5>
              <h2 className="title-1">
                SHARE YOUR MEMORIES WITH US BY TAGGING US
              </h2>
            </div>
            <div className="section-row section-row--p-sm">
              <div className="section-col-3">
                <article className="media-project-2">
                  <figure className="media__img">
                    <img
                      src={Share1}
                      style={{ maxWidth: "400px", maxHeight: "250px" }}
                      alt=""
                      aria-hidden="true"
                      loading="lazy"
                    />
                  </figure>
                  <div className="media__body">
                    <h3 className="media__title">
                      <a
                        href="https://www.instagram.com/oryzaleisure"
                        target="_blank"
                        rel="noreferrer"
                      >
                        #oryzaleisure
                      </a>
                    </h3>
                    <span className="address">Tag and follow us</span>
                  </div>
                </article>
              </div>
              <div className="section-col-3">
                <article className="media-project-2">
                  <figure className="media__img">
                    <img
                      src={Share2}
                      style={{ maxWidth: "400px", maxHeight: "250px" }}
                      alt=""
                      aria-hidden="true"
                      loading="lazy"
                    />
                  </figure>
                  <div className="media__body">
                    <h3 className="media__title">
                      <a
                        href="https://www.instagram.comhttps://pettipettimirissa.com"
                        target="_blank"
                        rel="noreferrer"
                      >
                        #pettipetti
                      </a>
                    </h3>
                    <span className="address">Tag and follow us</span>
                  </div>
                </article>
              </div>
              <div className="section-col-3">
                <article className="media-project-2">
                  <figure className="media__img">
                    <img
                      src={Share3}
                      style={{ maxWidth: "400px", maxHeight: "250px" }}
                      alt=""
                      aria-hidden="true"
                      loading="lazy"
                    />
                  </figure>
                  <div className="media__body">
                    <h3 className="media__title">
                      <a
                        href="https://www.instagram.com/kent_cottage"
                        target="_blank"
                        rel="noreferrer"
                      >
                        #kentcottage
                      </a>
                    </h3>
                    <span className="address">Tag and follow us</span>
                  </div>
                </article>
              </div>
              <div className="section-col-3">
                <article className="media-project-2">
                  <figure className="media__img">
                    <img
                      src={Share4}
                      style={{ maxWidth: "400px", maxHeight: "250px" }}
                      alt=""
                      aria-hidden="true"
                      loading="lazy"
                    />
                  </figure>
                  <div className="media__body">
                    <h3 className="media__title">
                      <a
                        href="https://www.instagram.com/bananabunkskandy"
                        target="_blank"
                        rel="noreferrer"
                      >
                        #bananabunkskandy
                      </a>
                    </h3>
                    <span className="address">Tag and follow us</span>
                  </div>
                </article>
              </div>
              <div className="section-col-3">
                <article className="media-project-2">
                  <figure className="media__img">
                    <img
                      src={Share5}
                      style={{ maxWidth: "400px", maxHeight: "250px" }}
                      alt=""
                      aria-hidden="true"
                      loading="lazy"
                    />
                  </figure>
                  <div className="media__body">
                    <h3 className="media__title">
                      <a
                        href="https://www.instagram.com/bananabunksmirissa"
                        target="_blank"
                        rel="noreferrer"
                      >
                        #bananabunksmirissa
                      </a>
                    </h3>
                    <span className="address">Tag and follow us</span>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
